import {Subscription} from '@domain/model/Account/Subscription/Subscription';
import {SubscriptionRepository} from '@domain/model/Account/Subscription/SubscriptionRepository';
import {SubscriptionDTO} from '@domain/model/Account/Subscription/SubscriptionDTO';

const SetSubscription =
  (subscriptionRepository: SubscriptionRepository): ((subscription: Subscription) => Promise<SubscriptionDTO | null>) =>
  (subscription: Subscription): Promise<SubscriptionDTO | null> => {
    if (!subscription.modality) {
      return Promise.resolve(null);
    }

    return subscriptionRepository.setSubscription(subscription);
  };

export {SetSubscription};
